// @flow
import "./index.css";
import "react-app-polyfill/ie11";

import App from "./App.jsx";
import React from "react";
import ReactDOM from "react-dom";
import client from "./links";
import { unregister } from "./serviceWorker";
import store from "./store";
import { ApolloProvider } from "react-apollo";
import { Provider as ReduxProvider } from "react-redux";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#6b6d88"
    },
    secondary: {
      main: "#0379c5"
    }
  },
  typography: {
    fontFamily: "DINNextLTPro-Regular, Helvetica, Arial, sans-serif"
  }
});

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <script src="http://metabase.canceriq.com/app/iframeResizer.js" />
    <CssBaseline />
    <ReduxProvider store={store}>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </ReduxProvider>
  </MuiThemeProvider>,
  document.getElementById("root")
);

unregister();
